export default
{
    watch:
    {
        options( newOptions, oldOptions )
        {
            // Maybe reset the value when options change. Make sure selected option is correct. - @return {[type]} [description]

            const shouldReset = () =>
            {
                if( typeof this.resetOnOptionsChange === 'function' )
                {
                    return this.resetOnOptionsChange( newOptions, oldOptions, this.selectedValue )
                }
                else
                {
                    return this.resetOnOptionsChange;
                }
            }

            if( !this.taggable && shouldReset() )
            {
                this.clearSelection();
            }

            if( this.modelValue && this.isTrackingValues )
            {
                this.setInternalValueFromOptions( this.modelValue );
            }
        },

        modelValue:
        {
            //Make sure to update internal value if prop changes outside

            immediate: true,

            handler( val )
            {
                if( this.isTrackingValues )
                {
                    this.setInternalValueFromOptions( val );
                }
            },
        },

        multiple()
        {
            //Always reset the value when the multiple prop changes. - @return {void}

            this.clearSelection();
        },

        open( isOpen )
        {
            if( isOpen )
            {
                this.typeAheadToLastSelected();
            }

            if( this.autoscroll && isOpen )
            {
                this.$nextTick( () => this.maybeAdjustScroll() );
            }

            this.$emit( isOpen ? 'open' : 'close' );
        },

        search()
        {
            // Anytime the search string changes, emit the 'search' event.
            // The event is passed with two parameters: the search string, and a function  that accepts a boolean parameter to toggle the loading state.

            this.$emit( 'search', this.search, this.toggleLoading )
        },

        loading( val )
        {
            // Sync the loading prop with the internal mutable loading value.

            this.mutableLoading = val;
        },

        typeAheadPointer()
        {
            if( this.autoscroll )
            {
                this.maybeAdjustScroll();
            }
        },

        filteredOptions()
        {
            for( let i = 0; i < this.filteredOptions.length; i++ )
            {
                if( this.selectable( this.filteredOptions[i] ) )
                {
                    this.typeAheadPointer = i; break;
                }
            }
        },

        selectedValue()
        {
            if( this.open )
            {
                this.typeAheadToLastSelected();
            }
        }
    }
}
